<template>
  <div class="schedule">
    <h1>课程大纲</h1>
    <table>
      <tbody>
        <tr>
          <td></td>
          <td><strong>一</strong></td>
          <td><strong>二</strong></td>
          <td><strong>三</strong></td>
          <td><strong>四</strong></td>
          <td><strong>五</strong></td>
          <td><strong>六</strong></td>
          <td><strong>日</strong></td>
        </tr>
        <tr>
          <td><strong>July</strong></td>
          <td><strong>18</strong></td>
          <td><strong>19</strong></td>
          <td><strong>20</strong></td>
          <td><strong>21</strong></td>
          <td><strong>22</strong></td>
          <td><strong>23</strong></td>
          <td><strong>24</strong></td>
        </tr>
        <tr>
          <td><strong>9:00-12:00</strong></td>
          <td>
            <b>人文计算与数字人文</b
            ><br /><br />专家致辞：美国数字人文资深学者<br /><br />课程规划介绍：主办方
          </td>
          <td><b>数字人文平台及数据库</b><br /><br />主讲：授课教师</td>
          <td><b>数字人文中的定量分析方法</b><br /><br />主讲：授课教师</td>
          <td><b>数字人文中的本体应用</b><br /><br />主讲：授课教师</td>
          <td><b>文本分析与挖掘</b><br /><br />主讲：授课教师</td>
          <td><b>社会网络分析与可视化分析</b><br /><br />主讲：授课教师</td>
          <td></td>
        </tr>
        <tr>
          <td><strong>14:00-16:60</strong></td>
          <td>
            <b>选题说明会</b>
            <li>指导教师团队介绍选题</li>
            <li>学员自我介绍</li>
            <li>师生互动</li>
          </td>
          <td><b>小组活动</b><br /><br />学员组队</td>
          <td><b>专题讲座</b><br /><br />主讲：数字人文新锐学者</td>
          <td><b>专题讲座</b><br /><br />主讲：数字人文新锐学者</td>
          <td><b>小组讨论</b><br /><br />选题研讨/师生互动</td>
          <td>
            <b>项目实践指导<br />小组开题汇报</b>
          </td>
          <td></td>
        </tr>
        <tr>
          <td><strong>July</strong></td>
          <td><strong>25</strong></td>
          <td><strong>26</strong></td>
          <td><strong>27</strong></td>
          <td><strong>28</strong></td>
          <td><strong>29</strong></td>
          <td><strong>30</strong></td>
          <td><strong>31</strong></td>
        </tr>
        <tr>
          <td><strong>9:00-12:00</strong><strong>（3学时）</strong></td>
          <td><b>数字人文应用案例</b><br /><br />小组报告</td>
          <td><b>数字人文应用案例</b><br /><br />小组报告</td>
          <td><b>专题讲座</b><br /><br />主讲：美国数字人文新锐学者</td>
          <td><b>专题讲座</b><br /><br />主讲：数字人文新锐学者</td>
          <td><b>专题讲座</b><br /><br />主讲：美国数字人文新锐学者</td>
          <td>
            <b>课程结业汇报</b>
            <li>小组汇报</li>
            <li>专家点评</li>
            <li>总结致辞</li>
          </td>
          <td></td>
        </tr>
        <tr>
          <td><strong>14:00-15:50</strong><strong>（2学时）</strong></td>
          <td><b>R语言文本分析专题</b><br /><br />主讲：授课教师</td>
          <td><b>R语言文本分析专题</b><br /><br />主讲：授课教师</td>
          <td></td>
          <td>
            <b>项目实践指导<br />小组课题指导</b>
          </td>
          <td></td>
          <td><b>课程成果海报展示</b></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Schedule",
};
</script>

<style lang="less" scoped>
.schedule {
  padding: 1rem 0;
  h1 {
    text-align: center;
    letter-spacing: 0.4rem;
    font-weight: normal;
    margin: 0 0 1rem;
  }
  table {
    margin: 0.3rem 0 0;
    border-collapse: collapse;
    font-size: 0.7rem;
    tr {
      td {
        padding: 1rem;
        li {
          font-size: 0.7rem;
        }
      }
    }
    tr:nth-of-type(2n-1) {
      background: #ddd;
    }
    tr:nth-of-type(2n) {
      background: #eee;
    }
  }
}
</style>
